module.exports = __webpack_public_path__ + "static/ro-trainings-4-8a942a7796731c2e53510af45b7ae93a.jpg";